export default {
  "additionalQuestion": {
    "adultFemale": "성인 여성",
    "adultMale": "성인 남성",
    "answerQuestions": "다음 추가 질문에 답변해 주십시오.",
    "checkinTime": "체크인 시간",
    "checkoutTime": "체크아웃 시간",
    "moreDetailed": "숙박세부내용",
    "notificationFromFacility": "시설 공지사항",
    "selectTime": "시간 선택",
    "view": "보다"
  },
  "base": {
    "account": "계정",
    "apply": "적용",
    "attachFile": "파일을 첨부",
    "backTo": "{0} 돌아가다",
    "booking": "예약",
    "browserWarning": "현재 이용하시는 브라우저는 지원하지 않습니다. 최신 브라우저를 설치하여, 다시 시도해 주시기 바랍니다.",
    "cancel": "취소",
    "close": "닫기",
    "confirm": "예약을 확정",
    "continue": "다음",
    "collapse": "축소",
    "delete": "삭제",
    "edit": "변경",
    "error": "대단히 죄송합니다. 시스템에 에러가 발생하였습니다. 잠시 후에 다시 시도해 주시기 바랍니다.",
    "error02": "대단히 죄송합니다. 처리중에 에러가 발생하였습니다. 잠시 후에 다시 시도해 주시기 바랍니다.",
    "errorPaymentMethod": "각 객실의 결제 방법이 다르므로 예약을 진행할 수 없습니다. 동일한 결제 방법으로 객실을 선택하거나 객실 별로 예약을 진행해 주십시오.",
    "errorCode": {
      "3001": "시간 초과 에러가 발생하였습니다. 결제 처리는 진행되지 않았습니다.",
      "3002": "결제 처리에 실패하였습니다.",
      "3003": "이 카드는 이용하실 수 없습니다.",
      "3004": "카드번호를 확인바랍니다.",
      "3005": "만료일이 올바른지 확인하십시오.",
      "3006": "3D Secure 인증에 실패했습니다.",
      "3007": "이용할 수 없는 카드를 입력했거나 카드번호가 잘못되었습니다.",
      "3008": "3D Secure 인증이 취소되었습니다.",
      "3009": "여러 번 리퀘스트를 받았기 때문에 3D Secure 인증을 중단했습니다.",
      "3011": "시간 초과 에러가 발생하였습니다. 결제 처리는 진행되지 않았습니다.",
      "3203": "대단히 죄송합니다. 처리중에 에러가 발생하였습니다. 잠시 후에 다시 시도해 주시기 바랍니다.",
      "3204": "결제에 실패했습니다. 다른 카드를 사용하거나 나중에 다시 시도하세요.",
      "3205": "이 카드는 이용하실 수 없습니다.",
      "3202": "포인트 잔액을 획득할 수 없습니다.",
      "3504": "포인트를 반환할 수 없습니다. 포인트 내역을 확인하십시오.",
      "2401": "{currentPoint} 포인트의 포인트 잔액입니다. {spendPoint}포인트를 사용할 수 없습니다."
    },
    "fileLimit80MB": "업로드할 수 있는 이미지는 1장당 80MB가 최대입니다.",
    "upTo30FilesError": "30개 이상의 파일을 첨부할 수 없습니다",
    "upTo30Files": "최대 30개 파일",
    "textLengthLimit": "답변 텍스트는 반드시 255자 이하로 입력해 주십시오.",
    "GDPR": "개인정보 보호규정",
    "here": "여기에서 체크인 / 아웃 날짜를 지정하시면 티켓(바우처)을 사용하여 예약으로서 확정할 수 있습니다.",
    "imageError": "이미지를 불러오는 데 실패하였습니다.",
    "join": "회원가입",
    "languages": {
      "en": "English",
      "ja": "日本語",
      "ko": "한국어",
      "zh_Hans": "簡体中文",
      "zh_Hant": "繁體中文"
    },
    "loading": "확인중...",
    "login": "로그인",
    "logout": "로그아웃",
    "logoutMessage": "이미 로그아웃되었습니다.",
    "memberSignIn": "회원 로그인",
    "memberSignUp": "회원 첫 웹사이트 등록",
    "next": "다음",
    "notSelected": "미선택",
    "noData": "데이터 없음",
    "optional": "임의",
    "pay": "지불",
    "previous": "돌아가기",
    "previousPage": "돌아가기",
    "privacyPolicy": "개인정보 보호법",
    "readMore": "더 보기",
    "readLess": "접기",
    "recommended": "추천",
    "remove": "삭제",
    "required": "필수",
    "requireMessage": "필수항목은 반드시 입력하셔야 합니다.",
    "reservationStatuses": {
      "cancelled": "취소완료",
      "done": "예약완료"
    },
    "save": "저장",
    "signInUp": "로그인/회원등록",
    "submit": "제출",
    "termError": "이어가기 위해서는 이용 약관에 동의해주세요.",
    "taxMessage": "일본의 소비세는 현재 8%입니다만,  2019년 10월을 기점으로 인상될 것으로 예상됩니다. 현재는 10월 이후의 예약에 대해서도 세금별도금액이 소비세 8%라는 전제로 표시됩니다. 번거롭게 해드려 죄송합니다만, 10월 이후의 숙박에 대해서는, 예약확인화면에서 세금포함금액을 정확한 금액으로서 참고바랍니다.",
    "termsOfUse": "이용규약",
    "topPage": "메인 페이지",
    "update": "업데이트",
    "warning": {
      "kidsChanged": "이 시설에서는 지정하신 검색 조건을 사용할 수 없어 아동 검색 조건이 변경되었습니다."
    }
  },
  "bookingResult": {
    "allUser": "모든 사용자",
    "availableBetween": "적용가능한 기간",
    "bath": "욕조",
    "bedCount": "{n}대",
    "book": "예약",
    "bookAirline": "항공권 첨부로 예약하기",
    "cancellationFreeUntil": "{0}까지 무료취소",
    "cancellationPolicy": "취소 규정",
    "discountAmount": "할인 금액",
    "excludeDuring": "다음 기간을 제외",
    "forNights": "{n}박 요금",
    "freeWifi": "무료 WiFi",
    "guests": "고객수",
    "includes": "포함",
    "planInformation": "포함",
    "lowestPriceInfo": "재고 상황이나 할인 조건에 따라 최저가격이 달력에 표시되지 않는 경우가 있습니다. 실제 가격은 달력에서 확인하시기 바랍니다.",
    "maxAdults": "어른은 최대{n}명까지 이용 가능합니다.",
    "meals": "식사",
    "memberExclusive": "회원한정(会員限定）",
    "membersOnly": "회원 전용",
    "nonSmoking": "금연",
    "noRoomFound": "대단히 죄송합니다. 해당 조건에 맞는 공실이 없습니다.",
    "tryChanging": "{0} 또는 시설을 변경하여 다시 시도해 주시기 바랍니다.",
    "tryItem": "날짜",
    "noRoomSelected": "객실이 선택되지 않았습니다.",
    "notAvailable": "예약 불가",
    "priceFor": "총금액",
    "priceForAdult": "성인 인원수 × {n}명",
    "priceForChild": "아동 인원수 × {n}명",
    "priceForRoom": "객실수",
    "paymentCreditCard": "신용 카드로 사전 결제",
    "paymentMethods": "지불방법",
    "paymentMethod": {
      "on_site": "현지 결제",
      "credit_card": "신용 카드로 사전 결제",
      "on_site_credit_card_required": "현지 결제 ( 사전에 신용카드를 등록하셔야 합니다.)",
      "deferred_payment": "후불",
      "credit_card_full": "신용카드로 전액 결제",
      "credit_card_deposit": "신용카드로 결제 보증",
      "bank_transfer": "은행 이체"
    },
    "paymentNewCreditCards": "신용카드로 선결제",
    "paymentRegisteredCreditCards": "등록하신 신용카드로 선결제",
    "planDetails": "플랜 세부정보",
    "plansLimitForUpdating": "기존에 선택하신 플랜은 변경하실 수 없습니다.",
    "price": "가격",
    "promotionMayChanged": "프로모션은 예고없이 종료일 이전에 변경되거나 종료될 수 있습니다.",
    "registerCard": "카드 등록하기",
    "regularRate": "정규 요금",
    "reservationStartDate": "예약 개시일",
    "showRoomDetails": "객실 세부정보 보기",
    "roomDetails": "객실 설명",
    "roomFeatures": "객실 정보",
    "roomLeft": "객실이 {n}개 남았습니다!",
    "roomRate": "요금",
    "rooms": "객실수",
    "roomSize": "객실 크기",
    "roomSizeUnit": {
      "tatami_mats": "조(1조 = 약 0.5평)"
    },
    "select": "선택",
    "selectNewDate": "새로운 일정으로 검색 ",
    "serviceFeeDesc": "OTA 결제 확인화면에 추가되는 서비스 요금을 포함합니다.",
    "sleeps": "고객수",
    "smoking": "흡연",
    "stopReservationUpdate": "예약 변경을 중단",
    "targetUser": "대상 사용자",
    "taxExcluded": "세금별도",
    "taxIncluded": "세금 포함",
    "toilet": "화장실",
    "totalPrice": "엔",
    "totalPriceForNights": "{n}박 합계요금 | {n}박 합계요금 | {n}박 합계요금",
    "viewAll": "모든 플랜을 표시",
    "viewClose": "원래대로",
    "viewGallery": "모든 사진 보기",
    "viewLess": "원래대로",
    "viewMore": "모든 플랜을 표시 ({n}건)",
    "viewAllRooms": "{n}객실 모두 보기",
    "wifi": "와이파이",
    "wifiOption1": "없음",
    "wifiOption2": "무료",
    "wifiOption3": "유료",
    "searchResults": "검색 결과:",
    "nPlans": "{n} 건",
    "nRoomTypes": "{n} 건"
  },
  "customAuth": {
    "failTitle": "로그인 실패.",
    "failDesc": "회원정보가 등록되어 있지 않아 로그인에 실패했습니다."
  },
  "cancellationPolicy": {
    "policyHeader": "취소요금은 아래와 같습니다:",
    "policyLine": "숙박일{0}일전  요금의{1}%",
    "freePolicyLine": "숙박일{0}일전  요금의0%",
    "noShowLine": "노쇼의 경우 요금의{0}%",
    "cancelOnTheDay": "숙박당일 요금의{0}%",
    "ifBookedElsewhere": "타사 사이트나 여행사를 통해서 하신 예약의 취소는 각 사이트・여행사에 문의해 주시기 바랍니다.",
    "specialRate": "특별 취소수수료: {0}",
    "guest": "고객"
  },
  "calendar": {
    "fullyBooked": "예약 만석",
    "roomsLeft": "남은 객실수",
    "selected": "숙박예정일",
    "unavailable": "공실없음"
  },
  "corporateAdmin": {
    "admin": "관리자",
    "checkInDate": "체크인 날짜",
    "download": "다운로드",
    "guestName": "고객명",
    "hotelName": "호텔명",
    "maxNumberStay": "최대 숙박일수",
    "maxNumberStays": "최대 숙박일수",
    "nMonths": "{n}개월",
    "nights": "숙박 일수",
    "numberOfRooms": "객실수",
    "remaining": "숙박가능일수",
    "reservationData": "예약정보",
    "reservationDataDesc1": "※ 이용 내역은 전용 홈페이지에서 예약하신 분의 합계로 숙박 수를 표시하고 있습니다. 따라서 다른 예약 (전화 등) 에 대해서는 반영되지 않으므로 주의하시기 바랍니다.",
    "reservationDataDesc2": "※ 예약・숙박하고 나서, 그 내용이  전용 홈페이지에 반영될 때까지 수분~수십분 정도 시간이 걸리는 경우가 있습니다. 미리 양해 부탁드립니다.",
    "reservationDataDesc3": "※ 전용 홈페이지 이외로 의뢰된 숙박 내용의 변경・취소는 이 화면에는 반영되고 있지 않습니다.",
    "reservationDate": "예약일",
    "reservationNumber": "예약 번호",
    "reserved": "숙박완료일수",
    "status": "상태",
    "title": "기업 관리자",
    "totalPrice": "요금",
    "period": "기간",
    "year": "년"
  },
  "creditCardForm": {
    "addNewCard": "새 신용카드를 추가",
    "cardExpiration": "유효기간",
    "cardExpirationConfirm": "유효기간을 확인바랍니다.",
    "cardHolder": "카드 명의자",
    "cardHolderConfirm": "카드명의를 확인바랍니다.",
    "cardHolderFormatError": "이름은 반각 로마자로 입력해 주시기 바랍니다.",
    "cardHolderHelp": "카드에 명시된 이름을 입력해 주십시오.",
    "cardNumber": "카드 번호",
    "cardNumberConfirm": "카드번호를 확인바랍니다.",
    "cardNumberHelp": "카드번호를 입력해 주십시오.",
    "cardRequired": "카드 정보는 예약 확보의 목적이며, 즉시 결제되거나 하지는 않습니다. 취소 요금이 발생할 경우에만, {0}에 따라 카드 결제가 청구됩니다.",
    "cardSecurityCode": "세큐리티코드(CVV)",
    "cardSecurityCodeConfirm": "세큐리티코드(CVV)를 확인바랍니다.",
    "cardSecurityCodeHelp": "CVV",
    "creditCard": "신용카드",
    "expiredError": "체크아웃 날짜까지 유효한 신용카드를 등록해 주십시오",
    "month": "월",
    "payInAdvance": "이 결제방법은, {0}에 의한 수배・신용카드에 대한 사전결제입니다.",
    "payInAdvanceVoucher": "이 결제방법은, {0}에 의한 수배・신용카드에 대한 사전결제입니다.",
    "tappayNote": "해당 시스템은 TapPay 2048-bit SLL 트랜잭션 시스템을 사용하며, 고객의 카드 정보는 저장되지 않습니다. 또한 TapPay는 PCI DSS 서비스 제공자 레벨 1의 인증을 통해 신용카드 정보를 보호합니다.",
    "year": "년",
    "cardBrand": "카드 브랜드",
    "cardBrandMismatch": "카드 번호는 선택한 카드 브랜드에 속하지 않습니다.",
    "paymentOverMillionError": "100만엔을 넘는 온라인 결제는 VISA, Master 카드로는 이용하실 수 없습니다. 다른 카드 브랜드를 이용하거나 다른 결제 타입을 선택하십시오.",
    "badCards": "시스템 변경으로 인해 다음 카드는 신규 예약에 이용할 수 없습니다. 번거로우시겠지만 카드 정보를 다시 입력해 주십시오."
  },
  "gmoPaypalOptions": {
    "null": "카드 브랜드를 선택하십시오.",
    "visa": "VISA",
    "master": "Mastercard",
    "mastercard": "Mastercard",
    "amex": "American Express",
    "jcb": "JCB",
    "diners": "Diners Club"
  },
  "downloadPasswordModal": {
    "label": "암호화를 위해 비밀번호를 입력해 주시기 바랍니다. 다운로드 하신 zip파일은 이 비밀번호를 입력하시면 압축을 해제하실 수 있습니다."
  },
  "extraItems": {
    "error": {
      "extraNumber": "{name}의 개수를 변경하십시오. 예약 가능한 개수는 {min}〜{max}입니다."
    }
  },
  "facilitySuggestion": {
    "distanceFrom": "거리 :이 시설로부터 {n}km",
    "from": "최저요금",
    "header": "숙박 가능한 인근시설",
    "soldOut": "공실이 없습니다. 원하는 조건을 변경하고 다시 검색하십시오.",
    "soldOutDesc": "죄송합니다.지정 조건으로 예약 가능한 객실은 없습니다.",
    "visitHotelWebsite": "시설 웹사이트 보기"
  },
  "guestDetail": {
    "afterUpdate": "변경 후",
    "bookingForSomeone": "예약자와 투숙자가 다를 경우 클릭해서 투숙객 정보를 입력해 주세요.",
    "brrDiscount": "최적의 객실 요금 할인",
    "confirmUpdates": "예약 변경 확정",
    "confirmPayByCard": "신용카드 결제 확인",
    "coupon": "쿠폰",
    "couponApplied": "{code}이 적용되어 있습니다.",
    "creansmaerdCouponApplied": "{name}이 적용되어 있습니다.",
    "couponCode": "쿠폰 코드",
    "couponDiscount": "쿠폰 할인",
    "couponExpired": "이 쿠폰 코드는 유효하지 않습니다.",
    "couponInvalid": "입력된 쿠폰 코드가 올바르지 않습니다.",
    "couponLimitReached": "쿠폰 {code} 은 이용 한도에 도달했기 때문에 이용하실 수 없게 되었습니다.",
    "couponMaxStays": "쿠폰 할인은 숙박 첫날 기준 최대 {n}박까지 적용할 수 있습니다. 숙박 첫날 기준 {n}박 이후에는 일반 요금이 청구됩니다.",
    "couponTargetPlans": "쿠폰 코드 적용 대상 플랜",
    "couponNotUse": "쿠폰을 사용하지 않습니다",
    "couponValidUntil": "{date}까지 유효합니다",
    "creditCardWarning": "결제한 요금 전액을 환불하며, 예약 변경 후의 가격으로 청구합니다.",
    "day": "{n}일차",
    "email": "이메일 ({email}을 수신설정에서 허용해 주시기 바랍니다.)",
    "emailAgain": "메일(확인용)",
    "emailAgainConfirm": "메일주소가 일치하지 않습니다.",
    "emailAgainHelp": "메일주소를 다시 한 번 입력하십시오",
    "emailConfirm": "올바른 메일주소를 입력하십시오",
    "emailHelp": "메일주소를 입력하십시오",
    "extras": "옵션 판매",
    "fullName": "성명",
    "fullNameError": "성명을 알파벳(로마자)로 입력해 주시기 바랍니다.",
    "guestDetails": "고객정보",
    "guestName": "고객명",
    "guestNameError": "성명을 알파벳(로마자)로 입력해 주시기 바랍니다.",
    "guestNameHelp": "이름을 입력하십시오",
    "guestNameKanji": "숙박자명(한자)",
    "guestStayName": "고객명",
    "mainGuest": "main guest",
    "notes": "주의 사항",
    "originalPaymentAmount": "기존 결제 금액",
    "promotionDiscount": "할인",
    "phone": "전화번호",
    "phoneConfirm": "정확한 전화번호를 입력하시기 바랍니다",
    "phoneHelp": "전화번호를 입력하십시오",
    "priceBecomeCheaper": "현재 선택중인 플랜에 적용되는 프로모션 내용이 시설에 의해 변경되어, 가격이 인하되었습니다. 현재 가격을 확인하시고 예약을 진행해 주시기 바랍니다.",
    "priceBecomeExpensive": "대단히 죄송합니다만, 현재 선택중인 플랜에 적용되는 프로모션 내용이 시설에 의해 변경되어, 가격이 인상되었습니다. 현재 가격을 확인하시고 예약을 진행해 주시기 바랍니다.",
    "priceDiff": "가격 차액",
    "signupTerms": "본 예약시스템은 tripla(주)에 의해 제공되며, 고객의 개인정보는 tripla(주)와 공유됩니다.  본인은 이를 인지하고 회원등록을 진행함으로써, tripla {0} , {1} 및 , {2} 에 동의합니다.",
    "terms": "본 예약시스템은 tripla(주)에 의해 제공되며, 고객의 개인정보는 tripla(주)와 공유됩니다. 본인은 이를 인지하고 예약을 완료함으로써,  tripla {0} , {1} 및 , {2} 에 동의합니다.",
    "totalAmountWithTax": "합계 금액 (세금포함)",
    "totalWithoutTax": "합계 금액 (세금별도)",
    "updateUserInformation": "위의 내용으로 멤버십 정보를 업데이트합니다 ( 이메일 제외)"
  },
  "lineLogin": {
    "buttonText": "LINE으로 로그인"
  },
  "meta": {
    "facilities": "브랜드 시설",
    "sign_in": "로그인",
    "organization_sign_in": "법인 로그인",
    "sign_up": "회원가입",
    "search_results": "숙박 플랜 목록",
    "guest_detail": "고객 정보 입력",
    "payment_method": "결제 정보 입력",
    "completed": "예약 완료",
    "my_account": "마이 페이지"
  },
  "membership": {
    "promotionRate": "프로모션 내용",
    "regularRate": "정규요금",
    "signUpFor": "회원요금"
  },
  "membershipForm": {
    "address": "주소",
    "alreadyHaveAccount": "이미 계정을 가지고 있으신 분",
    "back": "돌아가기",
    "buildingName": "건물명・호실",
    "changePassword": "비밀번호 변경",
    "changePasswordResult": "패스워드 재설정",
    "changePasswordResult02": "✓ 고객님의 패스워드 재설정이 완료되었습니다.",
    "changePasswordResult03": "여기에서 다시 로그인 해주시기 바랍니다.",
    "changePasswordSecondary": "새로운 비밀번호를 입력해 주십시오",
    "confirmDeletedResult": "탈퇴처리가 완료되었습니다.",
    "confirmNewPassword": "비밀번호 확인",
    "confirmPassword": "비밀번호 확인",
    "confirmRegisterFail": "오류가 발생하였습니다.",
    "confirmRegisterFail02": "다시 등록해 주시기 바랍니다.",
    "confirmRegisterResult": "메일주소 인증",
    "confirmRegisterResult02": "✓ 성공적으로 등록되었습니다.",
    "confirmRegisterResult03": "즐거운 숙박 되시길 바랍니다",
    "createAccount2": "회원등록",
    "createAccount3": "회원등록",
    "dob": "생년월일",
    "email": "이메일 주소",
    "emailError": "메일 주소를 확인하시기 바랍니다",
    "emailPromotionCheck": "시설에서 프로모션 이메일 수신",
    "english_error": "알파벳으로 입력해 주십시오",
    "locale_error": {
      "ja": "알파벳으로 입력해 주십시오",
      "zh_Hant": "알파벳으로 입력해 주십시오",
      "ko": "한글 또는 알파벳으로 입력해 주십시오."
    },
    "enterDetail": "로그인 정보를 입력해주시기 바랍니다.",
    "first_name": "이름(영문)",
    "firstNameLocales": {
      "ja": "이름(영문)",
      "zh_Hant": "이름(영문)",
      "ko": "이름"
    },
    "first_name_kanji": "",
    "first_name_kanji_placeholder": "",
    "first_name_placeholder": "Gildong",
    "firstNamePlaceHolderLocales": {
      "ja": "Gildong",
      "zh_Hant": "Gildong",
      "ko": "길동"
    },
    "firstName": "이름",
    "firstNameError": "이름을 입력해 주시기 바랍니다",
    "firstNameKana": "",
    "forgotPassword": "비밀번호가 기억나지 않습니다",
    "forgotPassword02": "비밀번호 재설정",
    "forgotPasswordError": "입력하신 이메일 주소는 등록되어 있지 않습니다.",
    "forgotPasswordResult": "비밀번호 재설정",
    "forgotPasswordResult02": "✓ 메일이 전송되기까지 시간이 소요될 수 있습니다. 10분 정도가 경과해도 메일이 전송되지 않는 경우에는 아래의 재전송 버튼을 클릭하시면 재설정을 위한 이메일을 다시 전송합니다.",
    "forgotPasswordResultSecondary": "메일이 전송되기까지 시간이 소요될 수 있습니다. 10분 정도가 경과해도 메일이 전송되지 않는 경우에는 아래의 재전송 버튼을 클릭하시면 재설정을 위한 이메일을 다시 전송합니다.",
    "forgotPasswordSecondary": "이메일 주소를 입력해주시기 바랍니다. 이메일 계정으로 비밀번호를 재설정하실 수 있는 링크를 보내드립니다.",
    "gender": "성별",
    "generalError": "대단히 죄송합니다. 처리중에 에러가 발생하였습니다. 잠시 후에 다시 시도해 주시기 바랍니다.",
    "guest_first_name": "이름(영문)",
    "guest_first_name_kanji": "",
    "guest_last_name": "성(영문)",
    "guest_last_name_kanji": "",
    "header": "회원등록",
    "hiragana_error": "",
    "kanji_error": "",
    "last_name": "성(영문)",
    "lastNameLocales": {
      "ja": "성(영문)",
      "zh_Hant": "성(영문)",
      "ko": "성"
    },
    "last_name_kanji": "",
    "last_name_kanji_placeholder": "",
    "last_name_placeholder": "Hong",
    "lastNamePlaceHolderLocales": {
      "ja": "Hong",
      "zh_Hant": "Hong",
      "ko": "홍"
    },
    "lastName": "성",
    "lastNameError": "성을 입력해 주시기 바랍니다",
    "lastNameKana": "",
    "membershipId": "회원 번호",
    "membershipProgram": "Membership program",
    "name": "고객명",
    "nationality": "국적",
    "newPassword": "새 비밀번호 (알파벳 소문자 및 대문자 ・ 숫자를 최소 한 글자씩 포함하여 8자 이상)",
    "noAccount": "아직 회원등록을 하지 않으셨나요?",
    "occupation": "직업",
    "or": "또는",
    "orContinueBelow": "또는 다음 정보를 입력",
    "password": "비밀번호",
    "passwordConfirmationError": "비밀번호와 비밀번호 확인이 일치하지 않습니다.",
    "passwordError": "비밀번호를 확인하시기 바랍니다.",
    "passwordSignUp": "비밀번호 (알파벳 소문자 및 대문자 ・ 숫자 ・ 기호를 최소 한 글자씩 포함하여 8자 이상)",
    "pleaseSelect": "멤버십 프로그램을 선택",
    "postCode": "우편번호",
    "postCodeError": "알파벳과 숫자만 허용됩니다.",
    "prefecture": "시도군구",
    "notApplicable": "해당 없음",
    "privacyPolicy": "개인정보 보호정책",
    "promotionsCheckbox": "이메일로 이벤트 및 프로모션 관련 정보를 수신하겠습니다.",
    "resend": "재전송",
    "resendConfirmationEmail": "회원등록 확인메일이 도착하지 않으신 경우",
    "resendConfirmationEmailError": "이 메일주소는 등록되어 있지 않습니다.",
    "resendConfirmationEmailTitle": "회원등록 확인메일 재송신",
    "send": "전송",
    "setPassword": "변경",
    "setup": "회원등록",
    "setupResultSecondary01": "여기에서 체크인 / 아웃 날짜를 지정하시면 티켓(바우처)을 사용하여 예약으로서 확정할 수 있습니다.",
    "setupResultSecondary02": "등록하신 메일주소를 승인하기 위해 메일을 송신하였습니다. \n현재는 임시 등록 상태이므로 회원등록을 완료하시려면 메일에 기재된  URL로 접속해 주시기 바랍니다. 그 이후에 로그인 하실 수 있습니다.",
    "signIn": "로그인",
    "signInHere": "로그인",
    "signInTo": "{0}에 로그인",
    "signUp": "회원등록",
    "signUpResult": "이메일 주소를 승인해주세요.",
    "signUpResult02": "성공적으로 등록되었습니다.",
    "signUpResult02Secondary": "%{hotel_name}에 회원등록해주셔서 감사합니다.",
    "signUpResult02Secondary02": "A confirmation email has been sent to the email address you supplied.",
    "signUpResultSecondary": "%{hotel_name}에 회원등록해주셔서 감사합니다.",
    "signUpResultSecondary02": "계정을 이용하시려면, 입력하신 이메일을 승인해주셔야 합니다.",
    "signUpResultSecondary03": "이메일을 보내드렸습니다.",
    "signUpResultSecondary04": "로그인하시기 전에 이메일을 승인해 주시기 바랍니다.",
    "signUpSecondary": "회원등록을 하세요. 1분도 걸리지 않습니다.",
    "term": "{0} 및 {1}에 동의합니다.",
    "termError": "Please accept to the terms and conditions",
    "termOfUse": "이용약관",
    "wifi": "Free in-room wifi"
  },
  "membersihp": {
    "target": "대상 회원"
  },
  "myAccount": {
    "changeLoginEmail": "메일주소 변경",
    "changeLoginEmailDescription": "메일주소를 변경하시면, 새로운 메일주소로 확인 메일이 송신됩니다. 메일에 게재된 URL을 클릭하시면 변경이 완료됩니다. 메일주소를 잘못 입력하신 경우에는 재입력하시면, 마지막으로 변경하신 메일주소에 확인메일이 송신됩니다.",
    "changeLoginEmailPendingText": "새로운 메일주소가 확인중입니다. 업데이트시에 보내드리는 메일에 기재된 URL을 클릭하시면 반영됩니다.",
    "changePassword": "비밀번호 재설정",
    "confirmLoginEmail": "새로운 메일주소(확인중)",
    "edit": "편집",
    "emailLabel": "메일",
    "loginEmail": "메일",
    "loginInfo": "로그인 정보",
    "notRegistered": "아직 등록된 카드가 없습니다.",
    "pageTitle": "계정내용",
    "password": "비밀번호",
    "passwordLabel": "비밀번호",
    "paymentInfo": "결제 정보",
    "paymentOptions": "결제 방법",
    "paymentOptionsDesc": "편리하고 빠르게 결제하시려면, 결제하실 카드 정보를 저장하십시오. 모든 카드 정보는 완전하게 암호화되어 저장됩니다.",
    "pendingEmailText": "{n} 메일주소 확인중",
    "personalInfo": "개인 정보",
    "point": "포인트",
    "removeAccount": "회원탈퇴",
    "removeAccountConfirmationText": "정말 괜찮으십니까?",
    "removeAccountReason01": "더 이상 이용하지 않음",
    "removeAccountReason02": "숙박요금이 비쌈",
    "removeAccountReason03": "회원특전이 매력적이지 않음",
    "removeAccountReasonInput": "이유를 입력해주십시오",
    "removeAccountReasonOthers": "기타",
    "removeAccountSecondaryText": "회원탈퇴하시면 모든 회원 특전이 무효가 됩니다.",
    "removeAccountSecondaryText02": "또한 예약정보도 표시되지 않게 됩니다.",
    "removeCreditCard": "카드를 삭제",
    "removeCreditCardConfirm": "등록되어 있는 카드가 삭제됩니다. 진행하시겠습니까?",
    "resendEmail": "확인메일을 재송신",
    "resendEmailSuccess": "확인메일이 재송신되었습니다.",
    "yourCreditCards": "등록된 카드",
    "membershipId": "회원 아이디",
    "myQRCode": "내 QR 코드",
    "promotion": "프로모션",
    "historyStatus": {
      "expired": "만료된 포인트",
      "future": "획득 예정 포인트",
      "spent": "사용한 포인트",
      "gained": "획득 포인트",
      "refunded": "환불 포인트"
    },
    "value": "값",
    "badCards": "시스템 변경으로 인해 해당 카드는 신규 예약에 이용할 수 없습니다."
  },
  "myProfile": {
    "cancel": "예약을 취소",
    "cancelled": "취소됨",
    "change": "변경",
    "checkIn": "체크인:",
    "checkOut": "체크아웃:",
    "confirmationNo": "예약 번호",
    "multiRoom": "복수 객실",
    "myReservations": "예약 일람",
    "noResultButtonText": "공실을 검색하다",
    "noResultText": "아직 예약이 없습니다.",
    "pageTitle": "계정 정보",
    "viewDetails": "자세히 보기",
    "viewFlightDetails": "항공권 첨부 예약의 내역 확인"
  },
  "organization": {
    "enterDetail": "가지고 계신 ID・비밀번호를 입력해 주십시오. ",
    "signIn": "법인 로그인"
  },
  "ota": {
    "changeLoginEmailPendingText": "새로운 메일주소가 확인중입니다. 업데이트시에 보내드리는 메일에 기재된 URL을 클릭하시면 반영됩니다.",
    "name": {
      "agoda": "Agoda",
      "booking_com": "Booking com",
      "expedia": "Expedia",
      "jalan": "Jalan",
      "rakuten_travel": "Rakuten Travel",
      "rakutenTravel": "Rakuten Travel"
    },
    "priceNotAvailable": "이용할 수 없습니다."
  },
  "paymentMethod": {
    "paypalCheckbox1": "신용카드 발급 회사가 3D 보안을 지원하지 않는 경우에는 이용할 수 없습니다.",
    "paypalCheckbox2": "당사가 고객으로부터 수집한 아래의 개인정보 등은 카드 발급 회사가 실시하는 부정이용 검지, 방지를 위해 고객이 이용하고 있는 카드 발급 회사에 제공하겠습니다.",
    "paypalCheckbox3": "성명, 전화번호, 메일 주소, 인터넷 이용 환경에 관한 정보 등",
    "paypalCheckbox4": "고객이 이용하는 카드 발급 회사가 외국에 있는 경우, 이러한 정보는 해당 발급 회사가 속한 국가로 이전될 수 있습니다.",
    "paypalCheckbox5": "고객이 미성년인 경우, 친권자 또는 후견인의 승낙을 얻은 후에 본 서비스를 이용할 수 있습니다.",
    "credit_card": "사전결제",
    "deferred_payment": "후불",
    "on_site": "현지결제",
    "on_site_credit_card_required": "현지결제",
    "type": "지불유형",
    "twd_credit_card": "신용카드로 전액 결제",
    "twd_credit_card_deposit": "신용카드로 결제 보증",
    "bank_transfer": "은행 이체"
  },
  "pointHistory": {
    "cancellation": "취소",
    "dateColumn": "날짜",
    "descriptionColumn": "내용",
    "failToLoadErrorMessage": "포인트 이력을 불러오는 데 실패하였습니다.",
    "noData": "포인트 이력이 없습니다.",
    "pointExpirationColumn": "유효기간",
    "pointHistory": "포인트 이력",
    "pointsColumn": "포인트 수",
    "pointUse": "포인트이용",
    "stay": "숙박",
    "viewMore": "전체 이력을 확인",
    "exchangeDigico": "포인트 교환",
    "exchangeDigicoDesc": "디지코 포인트로 교환하고자 하는 포인트 금액을 입력해주십시오. Digico 포인트는 Amazon, Apple, Google 포인트를 포함한 다른 포인트 프로그램으로 포인트를 교환하는 데 사용할 수 있습니다. 이 절차는 되돌릴 수 없으며 Digico 포인트는 교환 후 180일 동안만 유효합니다. 이 서비스는 일본 국내에서만 액세스할 수 있습니다. 시설은 교환된 Digico 포인트에 대한 질문에 답변할 수 없습니다. Digico 포인트에 대한 자세한 내용은 {0}을 참조하십시오.",
    "exchangeDigicoLink": "여기",
    "exchangeDigicoLog": "디지코 포인트 교환",
    "exchangeAvaliablePoints": "이용 가능한 총 포인트",
    "exchangeBtn": "교환",
    "exchangeHistory": "포인트 교환",
    "exchangedAmount": "교환 금액",
    "exchangedDigicoCode": "코드",
    "exchangeConfirm": "이 프로세스는 되돌릴 수 없습니다. 포인트 교환을 확인하시겠습니까?",
    "exchangeConfirmBtn": "계속하다",
    "digicoPointUrl": "디지코 포인트 교환 URL:",
    "invalidAmount": "유효한 포인트 금액을 입력하십시오.",
    "totalBalance": "총 사용 가능 포인트",
    "currentPoints": "사용 가능한 포인트",
    "futurePoints": "획득 예정 포인트"
  },
  "pointSpending": {
    "balance": "이용가능 포인트",
    "errors": {
      "incorrectAmount": "포인트는 {n}포인트씩 이용하실 수 있습니다.",
      "moreThanPrice": "숙박금액 이상으로는 포인트를 이용하실 수 없습니다.",
      "upToBalance": "남아있는 포인트 이상으로는 설정하실 수 없습니다.",
      "pointUsageError": "모든 결제에 포인트를 이용하시는 경우 신용카드는 이용할 수 없습니다."
    },
    "minimumAmount": "포인트는 {0}포인트 이상부터 이용하실 수 있습니다.",
    "points": "포인트",
    "saveForLater": "포인트를 이용하지 않음",
    "updateRule": "기존 예약에 사용된 포인트는 사용하실 수 없습니다. 기존 예약에 사용된 포인트는 예약이 업데이트 된 후에 환불됩니다.",
    "useAll": "포인트를 전부 사용",
    "useAmount": "이용 포인트를 설정"
  },
  "progressBar": {
    "confirmationSubtitle": "객실이 예약되었습니다.",
    "confirmationTitle": "예약확정",
    "guestSubtitle": "고객 정보를 입력하십시오",
    "guestTitle": "고객 정보",
    "paymentSubtitle": "결제방법 선택",
    "paymentTitle": "결제"
  },
  "reservation": {
    "cancelled": "취소 완료",
    "completed": "숙박 완료",
    "upcoming": "예약중"
  },
  "reservationAction": {
    "applyGOTO": "쿠폰 코드를 적용",
    "bookingCancel": "예약을 취소",
    "bookingUpdate": "고객정보를 변경",
    "corporateSignInRequired": "예약을 변경하시려면 법인(조직) 로그인이 필요합니다",
    "differentFacilityWarning": "예약을 변경하시려면 예약하신 시설로 로그인하십시오.",
    "everythingCorrectSubtitle": "아래에서 이 예약의・고객정보를 변경 취소하실 수 있습니다.",
    "everythingCorrectTitle": "예약관리",
    "invoiceDownload": "청구서를 다운로드",
    "madeMistakeHelp": "또 이용해주시기 바랍니다.",
    "madeMistakeTitle": "예약이 취소되었습니다.",
    "memberSignInRequired": "예약을 변경하시려면 회원 로그인이 필요합니다",
    "pleaseCancelAll": "모든 객실을 취소하실 경우에는 예약을 취소해 주십시오.",
    "payByCreditCard": "신용카드로 사전 결제",
    "reductionOfNights": "숙박 기간 단축",
    "reductionOfRooms": "객실 일부 취소",
    "selectRoomsToCancel": "취소할 객실을 선택해 주십시오",
    "signOutRequired": "예약을 변경하시려면 로그아웃이 필요합니다",
    "updateExpired": "본 예약은 변경 기한이 지난 관계로, 예약 변경이 불가능합니다.",
    "updateItinerary": "예약 변경",
    "differentAccountWarning": "올바른 계정으로 로그인하여 예약을 업데이트하십시오.",
    "differentOrgWarning": "올바른 법인(조직)으로 로그인하여 예약을 업데이트하십시오.",
    "coupon": {
      "signOutRequired": "로그아웃하고 쿠폰을 적용하십시오.",
      "memberSignInRequired": "쿠폰을 적용하려면 회원 등록이 필요합니다.",
      "corporateSignInRequired": "쿠폰을 적용하려면 법인 로그인이 필요합니다.",
      "differentFacilityWarning": "쿠폰을 적용하려면 예약한 시설에서 로그인하십시오..",
      "differentAccountWarning": "쿠폰을 적용하려면 올바른 계정으로 로그인하십시오.",
      "differentOrgWarning": "쿠폰을 적용하려면 올바른 법인(조직)으로 로그인하십시오."
    }
  },
  "reservationCancellation": {
    "cancel": "예약 취소",
    "cancellationConfirm": "정말 예약을 취소 하시겠습니까?",
    "cancellationFee": "취소요금으로서",
    "cancellationOnDay": "온라인상에서는 당일 취소가 불가능합니다.",
    "cancellationPolicy": "취소 규정",
    "cancellationTitle": "예약을 취소",
    "contactByChatPhone": "번거로우시더라도, 전화로 연락주시기 바랍니다.",
    "contactByPhone": "번거로우시더라도, 전화로 연락주시기 바랍니다.",
    "contactPhone": "전화번호 {0}",
    "keep": "예약 유지",
    "nonRefundable": "환불불가",
    "reason": "취소사유를 알려주십시오",
    "reasonDifferentHotel": "다른 호텔을 이용하려 합니다.",
    "reasonNbTrvellers": "인원 수가 변경되었습니다.",
    "reasonOther": "기타",
    "reasonOtherHelp": "기타 다른 사유가 있으시면 알려주십시오.",
    "reasonRoomCheaper": "다른 사이트의 가격이 더 저렴합니다.",
    "reasonTripCancelled": "여행이 취소되었습니다.",
    "roomNbCancelFee": "Room {0} cancellation fee",
    "totalCancelFee": "Total cancellation fee"
  },
  "reservationConfirmation": {
    "cancellationFreeUntil": "{0} 까지 취소무료",
    "cannotChangePlan": "기존 예약에 포함된 숙박 플랜은 변경이 불가능합니다.",
    "confirmationEmail": "예약확인메일이 {0}로 송신되었습니다.",
    "extra": {
      "answer": "답변",
      "dateTime": "이용일시",
      "extrasPrice": "옵션",
      "items": "선택 수량",
      "notes": "주의 사항",
      "price": "가격",
      "priceIncludeTax": "요금(세금포함)",
      "question": "질문",
      "roomPrice": "객실 요금 합계"
    },
    "extrasSubtotal": "옵션요금 소계",
    "nonRefundableReminder": "본 플랜은 환불 불가입니다. 취소 시 환불이 불가능합니다.",
    "originalReservationPlans": "기존 예약에 포함된 숙박 플랜.",
    "reservationDetail": "예약 내용",
    "selectNewItinerary": "변경 원하시는 숙박기간과 인원수를 선택하시기 바랍니다.",
    "updateBooking": "예약 변경"
  },
  "reservationDetail": {
    "adult": "{n}",
    "checkIn": "체크인",
    "checkOut": "체크아웃",
    "child": "{n}",
    "dayUse": "당일 이용",
    "discount": "할인금액",
    "discountedPrice": "포인트 할인",
    "guest": "{n}",
    "maxGuests": "최대 정원",
    "night": "{n}박",
    "nights": "숙박 일수",
    "numberOfGuest": "객실수",
    "numberOfNights": "숙박 일수",
    "originalPrice": "지불 요금 합계",
    "pointDiscount": "포인트 할인금액",
    "pointInstruction": "포인트는 체크아웃 3일 후에 적립됩니다.",
    "pointReward": "이 예약으로 {0}인트가 지급됩니다.",
    "priceBreakDown": "요금 세부사항",
    "reservationNumber": "예약 번호",
    "roomDetails": "객실 정보",
    "roomNb": "객실 {0}",
    "roomPlan": "플랜명",
    "roomRate": "객실 요금",
    "roomType": "객실타입",
    "searchNecessary": "이 예약번호는 변경・취소시, 혹은 호텔에 문의하실 경우에 필요합니다.",
    "serviceFee": "서비스요금",
    "subTotal": "소계",
    "subTotalWithoutTax": "소계 (세금별도)",
    "tax": "세금",
    "taxIncluded": "세금포함",
    "total": "결제금액(세금포함)",
    "depositAmount": "보증금 ({0}%)",
    "remainAmount": "필요 잔액",
    "withTax": "세금포함",
    "depositNecessary": "예약을 확정하시려면 온라인 시스템을 통해 {0}%의 보증금을 지불하셔야 합니다."
  },
  "reservationPayment": {
    "creditCardPayment": "신용카드 결제",
    "onSitePayment": "현지결제(사전결제 불필요)",
    "paymentMethod": "지불방법",
    "pendingPage": {
      "launchButton": "해외안심결제",
      "text01": "버튼을 클릭하시면 해외안심결제 비밀번호 입력화면으로 이동합니다.",
      "text02": "15분 내에 비밀번호 입력을 완료하지 않으시면 예약이 중지됩니다.",
      "text03": "예약은 비밀번호를 입력하실때까지 확정되지 않습니다. 공실이 없어질 가능성이 있으므로 유의해 주시기 바랍니다.",
      "text04": "신용카드 결제는 tripla가 대행하기 때문에 3D 보안 점포명은 「tripla」라고 표시됩니다.",
      "timeOutError01": "시간 초과 에러가 발생하였습니다.",
      "timeOutError02": "결제 처리는 진행되지 않았습니다.",
      "authError01": "결제 처리에 실패하였습니다.",
      "error01": "예약 처리중에 에러가 발생하였습니다.",
      "error02": "결제 처리는 진행되지 않았습니다.",
      "error03": "「돌아가기」버튼을 클릭하셔서, 검색 결과 화면에서 예약을 다시 진행해 주시기 바랍니다."
    },
    "planError": "現在、このプランでは、選択したお支払い方法はご利用いただけません。再度お試しください",
    "selectCreditCards": "신용카드를 선택하십시오"
  },
  "reservationReceipt": {
    "customerName": "성명",
    "deferredWithoutDownload": "후불이기 때문에 영수증은 발행되지 않습니다.",
    "download": "영수증다운로드",
    "downloadOnCheckout": "영수증은 체크아웃날짜 이후에 다운로드 가능합니다.",
    "onSite": "현지 결제의 경우, 영수증은 호텔 프론트데스크에서 발행해 드립니다."
  },
  "searchBar": {
    "addRoom": "객실 추가",
    "adult": "성인 {n}명",
    "adults": "성인 인원수",
    "age": "나이",
    "agree": "동의",
    "bed": "이불포함",
    "checkIn": "체크인",
    "checkInAndOut": "체크인날짜 - 체크아웃날짜",
    "checkOut": "체크아웃",
    "child": "아동 {n}명",
    "childN": "아동 {n}",
    "children": "아동 인원수",
    "childrenAgeAtCheckout": "체크아웃시 아동 연령",
    "childrenAgeInfant": "나이 {from}-{to}",
    "childrenAgePrimary": {
      "primary": "나이 {from}-{to}",
      "primaryBottom": "나이 {from}-{to}",
      "primaryTop": "나이 {from}-{to}"
    },
    "childrenAges": "아동의 나이를 알려주시겠습니까?",
    "childrenAgeSharedBed": "나이 {from}-{to}",
    "childrenMealBedding": {
      "meal_no": "식사・이불제외",
      "meal_no_bedding": "이불포함",
      "meal_same_as_adult_bedding": "식사・이불포함",
      "meal_yes": "식사포함",
      "meal_yes_bedding": "식사・이불포함"
    },
    "cookieConsent": "해당 웹사이트는 사용자 경험을 개선하기 위해 쿠키를 사용합니다. 해당 웹사이트를 계속 사용함으로써 사용자는 당사의 쿠키 동의에 동의하는 것입니다. 자세한 내용은 {0} 확인하십시오.",
    "privacyPolicy": "개인정보보호 정책을",
    "perRoomGuests": "1객실당 이용 인원수",
    "dates": "날짜",
    "dayUse": "당일치기 플랜을 검색",
    "defaultArea": "전 지역",
    "edit": "수정",
    "filter": "필터",
    "guests": "고객수",
    "hotel": "호텔",
    "maxChildrenWarning": "아동 정원은 성인 1인당 {n}명입니다.",
    "pleaseSelectHotel": "호텔을 선택해 주세요.",
    "room": "{n}객실",
    "rooms": "객실수",
    "search": "검색",
    "showOnlyAvailable": "예약 가능한 플랜만 표시",
    "sort": "정렬",
    "sortOption": {
      "price_high_to_low": "높은 가격순",
      "price_low_to_high": "낮은 가격순",
      "recommended": "추천순"
    },
    "to": "~",
    "undated": "날짜 미정",
    "nights": "숙박 일수",
    "yearOld": "만 {n}세",
    "undatedWarning": "객실마다 인원수가 다른 경우에는 날짜 미정 검색을 이용할 수 없습니다"
  },
  "searchReservation": {
    "enterDetail": "예약번호와 메일주소를 입력해주시기 바랍니다.",
    "enterReservationNumber": "예약번호를 입력해주시기 바랍니다.",
    "manageBooking": "숙박예약확인・취소",
    "searchFailed": "계속하시려면 다음 정보가 필요합니다. 이메일 혹은 예약번호가 확인되지 않습니다. 다시 시도해주시기 바랍니다."
  },
  "searchResultByPlan": {
    "hide": "숨기기",
    "planContent": "플랜 내용",
    "plans": "플랜",
    "rooms": "객실",
    "showPlan": "플랜 내용을 표시",
    "moreDetail": "더 보기"
  },
  "snsLogin": {
    "loginWith": "{0}로 로그인",
    "enterPassword": "계속하시려면 패스워드를 입력해 주십시오",
    "existingPrompt": "이미 {sns} 계정을 가지고 계신가요? {sns} 계정과 메일 /비밀번호로 로그인 하실 수 있습니다.",
    "signUpDescription": "{sns} 계정으로 접속해 주셔서 대단히 감사합니다. 회원 가입을 위해 나머지 정보를 입력해 주시기 바랍니다."
  },
  "voucher": {
    "cancel": "변경 취소",
    "confirm": "확정",
    "number": "티켓(바우처) 번호",
    "purchseComplete": "구입완료",
    "selectStay": "체크인 날짜를 선택해 주십시오",
    "stillVoucher": "이것은 숙박 티켓(바우처)입니다. 아직 정식 예약으로서의 체크인 / 아웃 날짜는 지정되어 있지 않습니다.",
    "ThankPurchase": "티켓을 구입해주셔서 감사합니다.",
    "update": "변경 확정",
    "updateItinerary": "예약을 변경",
    "updateItineraryDesc": "새로운 숙박일정을 지정하세요.「변경확정」버튼을 클릭하면 변경이 확정됩니다.",
    "usingVoucher": "예매 티켓으로 객실을 예약",
    "valid": "예매 티켓이 유효합니다",
    "voucherDesc": "여기에서 체크인 / 아웃 날짜를 지정하시면 티켓(바우처)을 사용하여 예약으로서 확정할 수 있습니다.",
    "voucherDetails": "티켓(바우처) 세부 내용",
    "voucherNumber": "티켓 번호"
  },
  "triplaPay": {
    "isPaid": "결제가 성공적으로 완료되었습니다",
    "isAlreadyPaid": "Already paid",
    "isFailed": "결제가 실패했습니다",
    "isCompleted": "결제가 성공적으로 완료되었습니다",
    "isRefunded": "결제 금액이 환불되었습니다.",
    "refundedAt": "환불 날짜",
    "paidAt": "결제일",
    "isCancelled": "결제가 취소되었습니다",
    "total": "결제금액",
    "pleaseReload": "해당 작업은 1시간 이내에 완료되지 않았습니다.「업데이트」버튼을 클릭하고 새로고침하십시오.",
    "reload": "업데이트",
    "subject": "지불 대상",
    "amountIsChanged": "결제 금액이 변경되었으므로「업데이트」버튼을 클릭하고 새로고침하십시오.",
    "terms": "본 결제 시스템은 tripla(주)에 의해 제공되며 고객의 개인정보는 tripla(주)와 공유됨을 이해하여 tripla{0}, {1}, {2}에 동의합니다.",
    "paypalTerms": "또한 카드 결제에는 PayPal을 이용하고 있으며, 카드의 이용 명세서에는 PayPal로 기재됩니다.",
    "temsOfUse": "이용약관",
    "privacyPolicy": "개인정보 보호법",
    "gdprPolicy": "개인정보 보호규정",
    "pleaseScan": "QR코드를 스캔해주세요"
  },
  "triplaPayIssues": {
    "INVALID_PARAMETER_SYNTAX": "입력한 정보를 확인하세요.",
    "INVALID_EXPIRATION_YEAR": "만료일이 올바른지 확인하십시오.",
    "Invalid_card_number": "카드번호를 확인바랍니다.",
    "Others": "입력한 정보를 확인하세요."
  }
}